import {
	Banner,
	Button,
	ButtonGroup,
	Card,
	DescriptionList,
	Stack,
	TextField
} from '@shopify/polaris';
import Amplify, { API } from 'aws-amplify';
import { Form, Formik } from 'formik';
import _ from 'lodash';
import { useState } from 'react';
import './App.css';
import awsExports from './aws-exports';
import OrderLines from './OrderLines';

Amplify.configure(awsExports);
Amplify.register(API);

function App() {
	const [rows, setRows] = useState(null);
	const [searched, setSearched] = useState(false);
	const [sentItems, setSentItems] = useState();

	async function handleSubmit(values) {
		setRows();
		const { orderId, email } = values;
		const data = await API.get('orders', '/find', {
			queryStringParameters: {
				orderId,
				email,
			},
		});
		setRows(data ? data.rows : []);
		setSearched(true);
	}

	if (sentItems) {
		return (
			<div style={{ margin: '10px' }}>
				<Card title="Request to ship items" sectioned>
					<div>
						<Banner>We have successfully sent your request to ship these items. </Banner>
					</div>
					<div className="App-small-width">
						<Card.Section>
							<DescriptionList
								items={_.map(sentItems, o => ({
									term: `${o.order}`,
									description: `${o.quantity} ${o.quantity > 1 ? 'pcs' : 'pc'} ${o.item}`
								}))}
							/>
							<p style={{ marginTop: 15 }}>You will receive the tracking number via email. Extra shipping fee charges will be collected once you receive the items.</p>
						</Card.Section>
					</div>
				</Card>
			</div>
		)
	}

	return (
		<Formik
			initialValues={{ email: '', orderId: '' }}
			onSubmit={handleSubmit}
		>
			{({
				values,
				handleChange,
				handleBlur,
				isSubmitting,
				submitForm,
				setFieldValue
			}) => {
				const { orderId, email } = values;
				const canSearch = !_.isEmpty(orderId) && !_.isEmpty(email);

				function handleTrack() {
					submitForm();
				}

				function handleSearchAgain() {
					setSearched(false);
					setRows();
					setFieldValue('email', '');
					setFieldValue('orderId', '');
				}

				function handleDoneRequest(sentItems) {
					setSentItems(sentItems);
				}

				function handleTestFieldChanged(fieldName, value) {
					handleChange({
						target: {
							id: fieldName,
							value,
						},
					})
				}

				return (
					<div style={{ padding: '10px' }}>
						<Form>
							<Card title="Check Order Status Here">
								<Card.Section>
									<Stack spacing="tight" vertical>

										<p>
											To track your order, please enter your Order ID that was given 
											to you in the order confirmation email. You can enter more than
											one order ID by separating them by comma (e.g. 1829, 3782)
										</p>

										<div style={{ paddingTop: 10 }}>
											<Stack>
												<TextField
													label="Order ID"
													name="orderId"
													prefix="#"
													value={values.orderId}
													onBlur={handleBlur}
													onChange={(value) => handleTestFieldChanged('orderId', value)}
												/>
												<TextField
													label="Billing Email"
													name="email"
													type="email"
													inputMode="email"
													value={values.email}
													onBlur={handleBlur}
													onChange={(value) => handleTestFieldChanged('email', value)}
												/>
											</Stack>
										</div>

										<OrderLines
											email={values['email']}
											lines={rows}
											searched={searched}
											retryFn={handleSearchAgain}
											doneRequestFn={handleDoneRequest}
										/>

										{!searched && (
											<Stack
												distribution="leading"
												spacing="none"
											>
												<ButtonGroup>
													<Button
														loading={isSubmitting}
														onClick={handleTrack}
														disabled={
															isSubmitting ||
															!canSearch
														}
														primary
													>
														Track
												</Button>
												</ButtonGroup>
											</Stack>
										)}
									</Stack>
								</Card.Section>
							</Card>
						</Form>
					</div>
				);
			}}
		</Formik>
	);
}

export default App;